"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedDocumentsHttpService = void 0;
const shared_document_administration_1 = require("../../types/shared-documents/shared-document-administration");
const http_service_1 = require("../http.service");
/** Administration side of the shared-document space (#849). */
class SharedDocumentsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/documents`);
    }
    /**
     * Lists published documents, newest first, with their reading progress.
     *
     * @param payload - Page, page size and optional filters.
     * @returns The page.
     */
    getList(payload) {
        return this.get('', {
            params: {
                page: String(payload.page),
                per_page: String(payload.per_page),
                ...(payload.search ? { search: payload.search } : {}),
                ...(payload.audience ? { audience: payload.audience } : {}),
                ...(payload.scopeType ? { scopeType: payload.scopeType } : {}),
            },
            schema: shared_document_administration_1.listSharedDocumentsApiResponseSchema,
        });
    }
    /**
     * Publishes a PDF, sent as multipart.
     *
     * @param payload - The form, with the file.
     * @returns The document and the number of e-mails queued.
     */
    publish(payload) {
        const body = {
            title: payload.title,
            audience: payload.audience,
            scopeType: payload.scopeType,
            targetIds: payload.targetIds,
            mandatoryRead: payload.mandatoryRead,
            notifyByEmail: payload.notifyByEmail,
            file: payload.file,
        };
        if (payload.description) {
            body.description = payload.description;
        }
        return this.post('', {
            body,
            schema: shared_document_administration_1.publishSharedDocumentApiResponseSchema,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
    /**
     * Tells who a draft audience and scope reach now.
     *
     * @param payload - The draft audience and scope.
     * @returns The count and the first recipients.
     */
    previewRecipients(payload) {
        return this.post('recipients-preview', {
            body: payload,
            schema: shared_document_administration_1.previewSharedDocumentRecipientsApiResponseSchema,
        });
    }
    /**
     * Renders the notification e-mail as it will be sent.
     *
     * @param payload - The title, the mandatory-read flag, the audience and
     *   the greeted first name.
     * @returns The subject and the HTML.
     */
    previewNotification(payload) {
        return this.post('notification-preview', {
            body: payload,
            schema: shared_document_administration_1.previewSharedDocumentNotificationApiResponseSchema,
        });
    }
    /**
     * Lists the sites, open offices and active people of an audience that a
     * document can target.
     *
     * @param audience - The profile the document is for.
     * @returns The candidates.
     */
    getCandidates(audience) {
        return this.get('candidates', {
            params: { audience },
            schema: shared_document_administration_1.listSharedDocumentCandidatesApiResponseSchema,
        });
    }
}
exports.SharedDocumentsHttpService = SharedDocumentsHttpService;
